export * from './ngx-pagination-bootstrap.component';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/components/ngx-pagination-bootstrap-component/index.ts